@if (similarDocuments && similarDocuments.length > 0) {
  <div class="container">
    <div class="divider"></div>
    <div class="frame-165">
        <div class="frame-64">
          <img class="clipboard-text" src="../../assets/clipboard-text.png" />
        </div>
      <div class="introduction">Similar content</div>
    </div>
    <div class="content-row">
      @for (doc of similarDocuments; track doc; let i = $index) {
          <div class="card">
            @if (doc.type == 'document') {
              <span>
                @if (doc.coverImageURL) {
                  <a href="{{doc.url}}" class="pointer">
                    @if (doc.coverImageURL) {
                      <img src="{{doc.coverImageURL}}" class="card-img-top">
                    }
                  </a>
                }
                <div class="card-body">
                  <div class="card-text">
                    <a href="{{doc.url}}" class="pointer">
                      {{doc.name}}
                    </a>
                  </div>
                </div>
              </span>
            }
            @if (doc.type == 'post') {
              <span>
                <a (click)="launchPostDialog(doc.contentKey, '', '', false)"  class="pointer" >
                  @if (doc.coverImageURL) {
                    <img src="{{doc.coverImageURL}}" class="card-img-top">
                  }
                  <div class="card-body">
                  <!--h5 class="card-title">{{doc.name.slice(0, 30)}}</h5-->
                  <p class="card-text">
                    {{doc.name}}
                  </p>
                </div>
              </a>
            </span>
          }
        </div>
   
    }
  </div>
</div>
}

